import { checkIfScrollPositionIsGreaterThanThreshold } from "./scroll-snap.utils";

export function getNextScrollPosition({
  target,
  directionX,
  threshold,
  snapLengthX,
  handleSetCurrentItem,
  currentItem,
}: {
  target: HTMLElement;
  directionX: number;
  threshold: number;
  snapLengthX: number;
  handleSetCurrentItem?: (index: number) => void;
  currentItem?: number;
}) {
  // The current scroll position which is the distance from the left edge of the container.
  const left = target.scrollLeft;

  // the current scroll position as a ration of the container width
  // When the scroll position is within the container width the ration is less than 1.
  // When the scroll position is greater than container width but less than 2x the container width it is on the second item. etc.
  const currentScrollPositionX = left / snapLengthX;

  if (
    directionX === -1 &&
    checkIfScrollPositionIsGreaterThanThreshold(
      directionX,
      currentScrollPositionX,
      threshold,
    )
  ) {
    handleSetCurrentItem?.(Math.floor(currentScrollPositionX));
  }

  if (
    directionX !== -1 &&
    checkIfScrollPositionIsGreaterThanThreshold(
      directionX,
      currentScrollPositionX,
      threshold,
    )
  ) {
    handleSetCurrentItem?.(Math.ceil(currentScrollPositionX));
  }
}
